import React from 'react';
import { FormattedMessage } from 'react-intl';
import Button from '@material-ui/core/Button';

export const ValidateButton = ({ pending, disabled, onValidate, testId }) => (
    <Button
        variant="contained"
        color="primary"
        className="hia-ack-validate"
        onClick={onValidate}
        disabled={disabled || pending}
        data-testid={testId}
    >
        <FormattedMessage id={pending ? 'conventionPage.validate.pending' : 'conventionPage.validate.action'} />
    </Button>
);

// Last block of the page: validate the convention, then a confirmation in place (no link, no other page).
const ValidationSection = ({ acknowledged, expired, validation, onValidate, expiredNotice, sectionRef }) => (
    <section
        className="hia-ack-card hia-ack-card--validate"
        aria-labelledby="hia-ack-h-validate"
        data-section="validate"
        ref={sectionRef}
    >
        <h2 id="hia-ack-h-validate" className="hia-ack-h2"><FormattedMessage id="conventionPage.validate.heading" /></h2>
        {expired && expiredNotice}
        {!expired && acknowledged && (
            <div className="hia-ack-result hia-ack-result--ok" role="status" data-testid="validation-done">
                <p className="hia-ack-result-title"><FormattedMessage id="conventionPage.validate.done" /></p>
            </div>
        )}
        {!expired && !acknowledged && (
            <>
                <p className="hia-ack-note"><FormattedMessage id="conventionPage.validate.intro" /></p>
                <ValidateButton pending={validation.pending} onValidate={onValidate} testId="validate-main" />
                <div aria-live="polite">
                    {validation.errorId && (
                        <p className="hia-ack-inline-error" data-testid="validation-error">
                            <FormattedMessage id={validation.errorId} />
                        </p>
                    )}
                </div>
            </>
        )}
    </section>
);

export default ValidationSection;
